import DefaultClient from "@/apis/DefaultClient";
import ServiceStackClientContext from "@/contexts/apis/ServiceStackClientContext";
import { IAlert } from "@/contexts/data/AlertContext";
import IHasChildren from "@/types/components/IHasChildren";
import { Children, FC, useMemo, PropsWithChildren } from "react";

export interface IServiceStackClientProviderProps extends IHasChildren {
    baseUrl?: string;
    basePath?: string;
    onAlert?: (alert: IAlert) => void;
}

const ServiceStackClientProvider: FC<IServiceStackClientProviderProps> = ({
    basePath,
    baseUrl,
    onAlert,
    children
}) => {
    const client = useMemo(() => {
        return DefaultClient(baseUrl, basePath, onAlert);
    }, [basePath, baseUrl, onAlert])

    return (
        <ServiceStackClientContext.Provider value={client}>
            {children}
        </ServiceStackClientContext.Provider>
    );
}

export default ServiceStackClientProvider;